import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Stack } from '@mui/material';
import { whatsappTarget } from 'src/components/outbound/dialerModel';

// "WhatsApp" in the call-back box (CU-869fn2wcy). Calling WhatsApp from the box itself isn't built
// yet: this opens the person's WhatsApp chat, where the existing call button is.
export default function DialerWhatsappOption({ practiceId, leadId, archived, onOpened }) {
    const navigate = useNavigate();
    const target = whatsappTarget({ practiceId, leadId, archived });
    const open = () => {
        navigate(target.path, target.state ? { state: { goToWhatsappTab: Date.now() } } : undefined);
        onOpened();
    };
    return (
        <Alert severity="info" data-testid="dialer-whatsapp">
            <Stack spacing={1} alignItems="flex-start">
                <span>{target.text}</span>
                <Button size="small" variant="contained" onClick={open} data-testid="dialer-open-whatsapp" sx={{ textTransform: 'none !important' }}>
                    {target.button}
                </Button>
            </Stack>
        </Alert>
    );
}

DialerWhatsappOption.propTypes = {
    practiceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    leadId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    archived: PropTypes.bool,
    onOpened: PropTypes.func,
};
DialerWhatsappOption.defaultProps = { leadId: null, archived: false, onOpened: () => {} };
